export { default } from './AddFavorites';
